import ResponsiveImage from '@monofront/design-system/components/ResponsiveImage';
import { Description } from './Description';

interface IHeroCollectionHubProps {
  title: string;
  image?: string;
  descriptionHtml?: string;
}

const defaultCollectionVisualPath = '/images/default-collection-visual.jpg';

export const HeroCollectionHub: React.FC<IHeroCollectionHubProps> = ({
  title,
  image = defaultCollectionVisualPath,
  descriptionHtml,
}) => {
  return (
    <div className="tw-flex tw-flex-row tw-items-center tw-justify-between">
      <div>
        <h1
          className="tw-lf-title-sm tw-mb-4 desktop:tw-lf-title-lg desktop:tw-mb-3"
          data-testid="Hero collection hub title"
        >
          {title}
        </h1>
        <Description
          description={descriptionHtml}
          dataTestId="Hero collection hub short description"
        />
      </div>
      {image ? (
        <div
          className="tw-relative tw-ml-10 tw-hidden tw-h-[200px] tw-w-[373px] tw-shrink-0 desktop:tw-block [&>span]:tw-min-h-full [&_img]:tw-rounded-2xl"
          data-testid="Hero collection hub image"
        >
          <ResponsiveImage
            src={image}
            alt={title}
            layout="fill"
            objectFit="cover"
            priority
          />
        </div>
      ) : null}
    </div>
  );
};
